// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SlideOver(Props) {
  let title = Props.title;
  let actionsOpt = Props.actions;
  let onClose = Props.onClose;
  let children = Props.children;
  const actions = actionsOpt !== undefined ? actionsOpt : /* [] */ 0;
  const slideOverRef = React.useRef(null);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("section", {
      children: JsxRuntime.jsx("div", {
        ref: slideOverRef,
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("header", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h2", {
                    children: title._0,
                    className: "text-lg leading-7 font-medium text-gray-900"
                  }),
                  JsxRuntime.jsx("div", {
                    children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(actions, (function (index, action) {
                      const Key = "action-" + String(index);
                      return JsxRuntime.jsx("div", {
                        children: action,
                        className: "flex items-center"
                      }, Key);
                    }))),
                    className: "ml-auto flex space-x-2 items-center"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("svg", {
                        children: JsxRuntime.jsx("path", {
                          d: "M6 18L18 6M6 6l12 12",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: "2"
                        }),
                        className: "h-6 w-6",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }),
                      "aria-label": "Close panel",
                      className: "text-gray-400 hover:text-gray-500 transition ease-in-out duration-150",
                      onClick: (function (param) {
                        const slideOverEl = slideOverRef.current;
                        if (!(slideOverEl == null)) {
                          slideOverEl.classList.remove("animate-slideInFromRight");
                          slideOverEl.classList.add("animate-slideOutToRight");
                          setTimeout((function (param) {
                            Curry._1(onClose, undefined);
                          }), 300);
                          return;
                        }
                        
                      })
                    }),
                    className: "ml-3 h-7 flex items-center"
                  })
                ],
                className: "flex items-center"
              }),
              className: "px-4 sm:px-6"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: children,
                className: "absolute inset-0 px-4 sm:px-6"
              }),
              className: "relative flex-1 px-4 sm:px-6"
            })
          ],
          className: "h-full flex flex-col space-y-6 py-6 bg-white shadow-xl overflow-y-scroll"
        }),
        className: "w-screen max-w-md animate-slideInFromRight"
      }),
      className: "absolute inset-y-0 right-0 pl-10 max-w-full flex"
    }),
    className: "z-20 absolute inset-y-0 right-0 w-screen max-w-md overflow-hidden"
  });
}

const make = SlideOver;

export {
  make,
}
/* react Not a pure module */
